import React, { useEffect, useState, useCallback } from "react";
import { Buttons, Card, Container, Main, Header, Title, Content, Button } from "./style.js";
import api from "../../../services/api.js";
import { useLocation } from "react-router-dom";

export default function Avisos() {
  const [avisos, setAvisos] = useState([]);
  const [avisoAtual, setAvisoAtual] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();

  const buscarAvisos = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    setLoading(true);
    setError(null);

    try {
      const response = await api.get("/avisos");
      setAvisos(response.data || []);
    } catch (erro) {
      console.error("Erro ao buscar avisos:", erro);
      setError("Não foi possível carregar os avisos");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    buscarAvisos();
  }, [buscarAvisos, location.pathname]);

  const marcarComoVisualizado = async (id) => {
    try {
      await api.post(`/aviso-visualizado/${id}`);

      // Remove o aviso visualizado da lista
      setAvisos((prevAvisos) => prevAvisos.filter((aviso) => aviso.id !== id));

      // Reseta o índice se necessário
      if (avisoAtual >= avisos.length - 1) {
        setAvisoAtual(0);
      }
    } catch (erro) {
      console.error("Erro ao marcar aviso como visualizado:", erro);
      setError("Erro ao processar o aviso");
    }
  };

  // const proximoAviso = () => {
  //   if (avisoAtual < avisos.length - 1) {
  //     setAvisoAtual((prev) => prev + 1);
  //   }
  // };

  // const avisoAnterior = () => {
  //   if (avisoAtual > 0) {
  //     setAvisoAtual((prev) => prev - 1);
  //   }
  // };

  // Estados de loading e erro
  // if (loading) return <div>Carregando avisos...</div>;
  // if (error) return <div>Erro: {error}</div>;
  if (!avisos.length) return null;

  const aviso = avisos[avisoAtual];

  return (
    <Container>
      <Card>
        <Header>
          <Title>Aviso</Title>
          {avisos.length > 1 && (
            <span>
              {avisoAtual + 1} de {avisos.length}
            </span>
          )}
        </Header>

        <Main>
          <Content>{loading ? "carregando..." : error ?? aviso.descricao}</Content>
        </Main>

        <Buttons>
          <Button onClick={() => marcarComoVisualizado(aviso.id)} padding="10px">
            OK
          </Button>
        </Buttons>
      </Card>
    </Container>
  );
}
